import styled from 'styled-components';

export const ReportWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 550px;
`;

export const ScrollWrapper = styled.div`
  overflow-y: scroll;
`;

export const ReportWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  //margin: 5px 0;
  padding: 10px;
  //background: ${props => props.theme.colors.gray};
  background: #F5F5F5;
  &:nth-child(even) {
      //background: ${props => props.theme.colors.lighterGray};
      background: #FFFFFF;
  }
`;

export const TitleWrapper = styled.div`
  border-top: 1px solid ${props => props.theme.colors.gray};
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  margin: 0px 0px 10px 0px;
  padding: 10px 0;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/ReportWidgetGazzanet/styles.js